import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '@components/InspirationPagination/InspirationPagination.styles';
import InspirationProgressLine from '@components/InspirationProgressLine/InspirationProgressLine';
type PropsType = {
  actualCount: number;
  maxCount: number;
  handlePaginationButton: () => void;
  isInterior: boolean;
};
const InspirationPagination = ({
  actualCount,
  maxCount,
  handlePaginationButton,
  isInterior
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const getNextPageUrl = () => {
    const currentPath = router.asPath;
    const hasQuery = currentPath.includes('?');
    const currentPage = parseInt(router.query.page as string, 10) || 1;
    const nextPage = currentPage + 1;
    return hasQuery ? currentPath.replace(`page=${currentPage}`, `page=${nextPage}`) : `${currentPath}${currentPath.includes('?') ? '&' : '?'}page=${nextPage}`;
  };
  return <div sx={styles.paginationContainer(maxCount === 0)}>
      <div sx={styles.progressLineBox}>
        <InspirationProgressLine actualCount={actualCount} maxCount={maxCount} isInterior={isInterior} />
      </div>
      {actualCount !== maxCount && <span>
          <Link href={getNextPageUrl()} onClick={e => {
        e.preventDefault();
        handlePaginationButton();
      }} sx={styles.seeMoreButton} data-cy="VoxButtonPaginationNext">
            <span>{t('seeMore')}</span>
          </Link>
        </span>}
    </div>;
};
export default InspirationPagination;